import { t } from '@lingui/core/macro'
import { Accordion, Divider } from '@tecsinapse/cortex-react'
import React from 'react'
import { Usuario } from '@/core/types/graphql'
import { USUARIOS_STARTS_WITH } from '../data/usuarios-starts-with'
import { TriggerAccordion } from './trigger-accordion'
import { useFormContext } from 'react-hook-form'
import { FormAutocomplete } from '../../hook-form-connectors/form-autocomplete'

interface AccordionUsuariosManuaisProps {
  possuiUsuariosManuais: boolean
}

export const AccordionUsuariosManuais = ({
  possuiUsuariosManuais
}: AccordionUsuariosManuaisProps) => {
  const { control } = useFormContext()

  return (
    <div className={'mt-deca border border-secondary-light rounded-mili '}>
      <Accordion.Face direction={'vertical'}>
        <TriggerAccordion
          labelCheboxbox={t`Por usuário`}
          idCheckbox={'possuiUsuariosManuais'}
          value={possuiUsuariosManuais}
          fieldToClear={'usuariosManuais'}
        />
        <Accordion.Content direction={'vertical'}>
          <Divider />
          <div className={'p-deca h-[15rem]'}>
            <FormAutocomplete
              name='usuariosManuais'
              popoverClassName='max-h-[10rem] overflow-y-scroll'
              label={t`Usuário`}
              placeholder={t`Usuário`}
              query={USUARIOS_STARTS_WITH}
              useQueryAutocomplete
              dataPath='usuariosByNomeOrEmailStartingWith'
              optionSelectFromT={(it: Usuario) => ({
                value: it.id,
                label: `${it.nome} (${it.email})`
              })}
            />
          </div>
        </Accordion.Content>
      </Accordion.Face>
    </div>
  )
}
